<template>
  <b-select
    class="is-empty"
    v-model="value.data"
    placeholder="Select one">
    <option value="" disabled>Select One</option>
    <option
      v-for="choice in value.choices"
      :value="choice.value"
      :key="choice.value">
      {{ choice.label }}
    </option>
  </b-select>
</template>

<script>
export default {
  name: 'c-select',
  props: ['value'],
}
</script>



// WEBPACK FOOTER //
// src/lib/components/Select.vue